export default __webpack_public_path__ + "855424485e5c6d672b8b6c0c40828008.ttc";